module.exports = __webpack_public_path__ + "static/media/image_waypoint.f6c1702b.jpg";